import {
  BooleanInput,
  Create,
  NumberInput,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
  useNotify,
  useRedirect,
} from 'react-admin';
import { useLocation } from 'react-router-dom';

export const CommandParameterCreate = () => {
  const location = useLocation();
  const redirect = useRedirect();
  const notify = useNotify();

  // Get command_id from location state
  const commandId = location.state?.record?.command_id;

  const onSuccess = () => {
    notify('Parameter created successfully');
    redirect(`/commands/${commandId}`);
  };

  return (
    <Create mutationOptions={{ onSuccess }}>
      <SimpleForm defaultValues={{ command_id: commandId }}>
        <TextInput source="command_id" disabled defaultValue={commandId} />
        <TextInput source="name" validate={[required()]} fullWidth />
        <TextInput source="display_name" validate={[required()]} fullWidth />
        <TextInput source="description" multiline rows={3} fullWidth />
        <SelectInput
          source="data_type"
          choices={[
            { id: 'string', name: 'String' },
            { id: 'integer', name: 'Integer' },
            { id: 'boolean', name: 'Boolean' },
            { id: 'array', name: 'Array' },
            { id: 'object', name: 'Object' },
          ]}
          validate={[required()]}
        />
        <SelectInput
          source="ui_component"
          choices={[
            { id: 'text', name: 'Text Input' },
            { id: 'textarea', name: 'Text Area' },
            { id: 'number', name: 'Number Input' },
            { id: 'select', name: 'Select (Single)' },
            { id: 'multiselect', name: 'Multi-Select' },
            { id: 'checkbox', name: 'Checkbox' },
            { id: 'radio', name: 'Radio Buttons' },
          ]}
          validate={[required()]}
        />
        <BooleanInput source="is_required" />
        <NumberInput source="order" validate={[required()]} defaultValue={0} />
        <TextInput source="default_value" fullWidth />
        <TextInput source="validation_rules" multiline rows={2} fullWidth helperText="JSON validation rules" />
      </SimpleForm>
    </Create>
  );
};
